module.exports = __webpack_public_path__ + "static/media/important-message.7f7f2bc4.png";